import {DBSchema, openDB} from "idb";

interface Users extends DBSchema{
  username: {
    key: string;
    value: string;
  },
}

const dbPromise = openDB<Users>('users-db', 1, {
  upgrade(db) {
    db.createObjectStore('username');
  }
});

const get = async (key: string) => {
  return (await dbPromise).get('username', key);
};

const set = async (key: string, val: string) => {
  return (await dbPromise).put('username', val, key);
};

const keys = async () => {
  return (await dbPromise).getAllKeys('username');
};

const all = async () => {
  return (await dbPromise).getAll('username');
};

export {
  get,
  set,
  keys,
  all,
}
